<template>
  <nav
    class="custom-breadcrumb-nav"
    aria-label="breadcrumb"
    v-if="computedBreadcrumbs.length > 0"
  >
    <ol class="custom-breadcrumb-list">
      <li
        v-for="(item, index) in computedBreadcrumbs"
        :key="index"
        class="custom-breadcrumb-item"
      >
        <template v-if="item.to && index < computedBreadcrumbs.length - 1">
          <router-link :to="item.to" class="custom-breadcrumb-link">
            <unicon
              v-if="item.icon"
              :name="item.icon"
              class="unicon-breadcrumb-icon"
            ></unicon>
            <span :class="item?.icon ? 'text-icon' : ''">
              {{ item.params ? $t(item.text, item.params) : $t(item.text) }}
            </span>
          </router-link>
        </template>
        <template v-else>
          <span class="custom-breadcrumb-current">
            <unicon
              v-if="item.icon"
              :name="item.icon"
              class="unicon-breadcrumb-icon"
            ></unicon>
            <span :class="item?.icon ? 'text-icon' : ''">
              {{ item.params ? $t(item.text, item.params) : $t(item.text) }}
            </span>
          </span>
        </template>

        <span
          v-if="index < computedBreadcrumbs.length - 1"
          class="custom-breadcrumb-separator"
        >
          {{ separator }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "ReusableBreadcrumb",

  props: {
    // This prop is now the SOLE source of breadcrumb items
    customItems: {
      type: Array,
      default: () => [],
      // A basic validator to ensure items have at least 'text'
      validator: (items) =>
        items.every((item) => typeof item.text === "string"),
    },
    separator: {
      type: String,
      default: "/",
    },
  },

  // No data properties needed anymore for routeBreadcrumbs

  computed: {
    // computedBreadcrumbs now simply returns customItems
    computedBreadcrumbs() {
      return this.customItems;
    },
  },

  // No watch property needed for $route

  // No methods needed for generating breadcrumbs from route
};
</script>

<style scoped>
/* --- Base Styles --- */
.custom-breadcrumb-nav {
  font-family: Arial, sans-serif;
  font-size: 16px;
  color: #555;
  margin-top: 16px;
  margin-left: 8px; /* Changed margin-inline-end to margin-left for LTR consistency */
}
.text-icon {
  margin-inline-start: 5px; /* Adjust spacing between icon and text */
}
.custom-breadcrumb-list {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
}

.custom-breadcrumb-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.custom-breadcrumb-link,
.custom-breadcrumb-current {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.custom-breadcrumb-link {
  color: #007bff;
  text-decoration: none;
  transition: color 0.2s ease-in-out;
}

.custom-breadcrumb-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.custom-breadcrumb-current {
  color: #333;
  font-weight: bold;
}

/* --- Unicon Icon Styling --- */
.unicon-breadcrumb-icon {
  width: 1em; /* Make Unicon scale with font size */
  height: 1em; /* Make Unicon scale with font size */
  margin-inline-end: 5px; /* Space between Unicon icon and text */
}

/* --- Separator Styling --- */
.custom-breadcrumb-separator {
  margin: 0 8px;
  color: #999;
}
</style>
